import React from "react";
import {
  FormControl,
  FormLabel,
  HStack,
  Input,
  Select,
  Stack,
  Text,
} from "@chakra-ui/react";

const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

const formatRecordCount = (count) => `${count} record${count === 1 ? "" : "s"}`;

const PaginatedListToolbar = ({
  searchText,
  onSearchTextChange,
  searchPlaceholder = "Search",
  pageSize,
  onPageSizeChange,
  totalCount,
  sortKey,
  sortDir,
  sortOptions,
  onSortKeyChange,
  onSortDirChange,
  extraControls = null,
}) => (
  <Stack
    direction={{ base: "column", lg: "row" }}
    spacing={4}
    align={{ base: "stretch", lg: "end" }}
    justify="space-between"
    w="100%"
    mb={4}
  >
    <FormControl maxW={{ base: "100%", lg: "380px" }}>
      <FormLabel mb={1}>Search</FormLabel>
      <Input
        value={searchText}
        onChange={(event) => onSearchTextChange(event.target.value)}
        placeholder={searchPlaceholder}
      />
    </FormControl>

    <HStack
      spacing={4}
      align="end"
      flexWrap="wrap"
      justify={{ base: "space-between", lg: "flex-end" }}
    >
      <FormControl w={{ base: "calc(50% - 8px)", md: "140px" }} minW="140px">
        <FormLabel mb={1}>Sort by</FormLabel>
        <Select value={sortKey} onChange={(event) => onSortKeyChange(event.target.value)}>
          {sortOptions.map((option) => (
            <option key={option.key} value={option.key}>
              {option.label}
            </option>
          ))}
        </Select>
      </FormControl>

      <FormControl w={{ base: "calc(50% - 8px)", md: "140px" }} minW="140px">
        <FormLabel mb={1}>Direction</FormLabel>
        <Select value={sortDir} onChange={(event) => onSortDirChange(event.target.value)}>
          <option value="asc">Ascending</option>
          <option value="desc">Descending</option>
        </Select>
      </FormControl>

      <FormControl w={{ base: "calc(50% - 8px)", md: "120px" }} minW="120px">
        <FormLabel mb={1}>Page size</FormLabel>
        <Select
          value={pageSize}
          onChange={(event) => onPageSizeChange(Number(event.target.value))}
        >
          {PAGE_SIZE_OPTIONS.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </Select>
      </FormControl>

      {extraControls}

      <Text minW="96px" fontSize="sm" color="gray.500" mb={2}>
        {formatRecordCount(totalCount)}
      </Text>
    </HStack>
  </Stack>
);

export default PaginatedListToolbar;
